const humanizeSlug = (slug) => (slug || '').replace(/-/g, ' ').replace(/^./, (c) => c.toUpperCase());

export default humanizeSlug;
